import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as actions from '~/actions/formActions/embeddedBarcode';

import InputSelectBox from '~/components/input-select-box';
import InputBox from '~/components/input-box';


const typeOptions = [
  {value: 0, label: 'Embedded Price'},
  {value: 1, label: 'Embedded Weight'}
];

const pointOptions = {
  0: [
    {value: 0, label: '0'},
    {value: 1, label: '1'},
    {value: 2, label: '2'},
  ],
  1: [
    {value: 0, label: '0'},
    {value: 1, label: '1'},
    {value: 2, label: '2'},
    {value: 3, label: '3'},
  ]
};

function mapStateToProps(state, ownProps) {
  return state.forms.embeddedBarcode;
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

class SettingsBusinessEmbededBarcode extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  static propTypes = {
    type: PropTypes.number.isRequired,
    enabled: PropTypes.bool.isRequired,
    decimalPoints: PropTypes.number.isRequired,
    editMode: PropTypes.bool.isRequired,
    changed: PropTypes.bool.isRequired,
    enableSubmit: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    scale_barcode: PropTypes.object.isRequired,
  };

  componentDidMount() {
    let {store_id} = this.props.params;
    this.props.actions.showEmbeddedBarcodeSetting(store_id);
    this.props.actions.showScaleBarcodeNumber(store_id);

  }
  submitAction(){
    this.props.actions.submitScaleBarcodeSetting()
    this.props.actions.submitEmbeddedBarcodeSetting()
  }
  scalebarcodevali(prefix) {
    let { store_id } = this.props.params
    let prefixdata = [prefix]
    if(prefix){
      let ArrayPrefix = prefix.split(",")
      // not need show: 20,21,22,23,24,25,26,27,28
      let needShow = false 
      if(ArrayPrefix.length <= 9) {
        for(let i of ArrayPrefix){
          if( i < 20 || i > 29 || String(i).indexOf(".")>-1 || isNaN(i)) {
            needShow = true
          }
        }
      }else{
        needShow = true
      }
      if (needShow) {
        this.props.actions.showScaleBarcodeNumber(store_id);
      }
    }
  }

  render() {
    const {type, enabled, decimalPoints, editMode, changed, enableSubmit, actions, scale_barcodes} = this.props;
    return (
      <div className="bp">
      <div className="main-content">
        <header className="main-content-header columns">
          <h1 className="main-content-title columns-main"></h1>
          { !editMode && <button className="btn btn-secondary btn-sm" onClick={ actions.editEmbeddedBarcodeSetting }>Edit</button> }
          { editMode && <button className="btn btn-primary btn-sm" onClick={ ()=>{this.submitAction()} }>Save</button> }
        </header>
        <div className="main-content-section">
          <h1>Embedded Barcode</h1>
          <div>
            <p>
              <input type="checkbox"
                      value="1"
                      checked={ enabled }
                      disabled={ !editMode }
                      onChange={ (e) => actions.changeEmbeddedBarcodeEnabled(e.target.checked) }/>
                 Enable Embedded Barcode for by weight pricing product
            </p>
          </div>
        </div>
        { enabled && <div className="main-content-section">
            {typeOptions.map((typeOption, index) => (<div className="row" key={index}>
                <div className="col-md-3">
                  <InputBox value={ typeOption.label}
                            disabled={ !editMode }
                            title="Embedded Type"/>
                </div>

                <div className="col-md-3">
                  <InputBox value={ scale_barcodes[index].prefix }
                            disabled={ !editMode }
                            title="Scale Prefix"
                            // key={scale_barcodes[index].prefix}
                            onBlur = {() => this.scalebarcodevali(scale_barcodes[index].prefix)}
                            onChange = { e => actions.editScaleBarcode(e.target.value,typeOption.value)}/>
                </div>
                <div className="col-md-3">
                  <InputSelectBox value={ scale_barcodes.length!==0?scale_barcodes[index].decimal:'' }
                                  // key={index}
                                  title="Decimal Points"
                                  placeholder="Select decimal"
                                  resetValue={ undefined }
                                  clearable={ false }
                                  disabled={ !editMode }
                                  onChange={ (opt) => actions.changeEmbeddedBarcodeDeciamlPoints(opt.value, typeOption.value) }
                                  options={ pointOptions[index] || [] }/>
                </div>
              </div> ))}
        </div> }
      </div>
    </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsBusinessEmbededBarcode);



/** WEBPACK FOOTER **
 ** ./client/pages/settings/business/embedded-barcode/index.js
 **/